import './index.css'

const Footer = () =>{

    return (
            <div className="footer">Made With ❤️ By <span className="hl">Shubham.</span> © </div>
    )
}

export default Footer